import React, { ReactNode, useCallback, useState } from "react";
import { CircularProgress, IconButton, styled, Tooltip } from "@mui/material";
import { ReactComponent as ExcelIcon } from "./excel_icon.svg";
import exportToXls from "./exportToXls";

export enum ExportFormat {
  // PDF = 'pdf',
  // CSV = 'csv',
  XLSX = "xlsx",
}

const FormatsIcons: Record<ExportFormat, ReactNode> = {
  [ExportFormat.XLSX]: <ExcelIcon />,
};

interface ExportsDialogProps {
  data: any;
  formats: ExportFormat[];
  fileName: string;
  sheetName?: string;
  disabled?: boolean;
}

const ExportsDialogButtons = styled("div")({
  display: "flex",
  gap: 8,
  marginTop: 6,
});

const ButtonHolder = styled("div")({
  position: "relative",
  "& button svg": {
    height: 22,
    width: 22,
  },
  "& button:disabled": {
    opacity: 0.5,
  },
  "& .exporting": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

const ExportsDialog = ({
  data,
  formats,
  disabled,
  fileName,
  sheetName,
}: ExportsDialogProps) => {
  const [exporting, setExporting] = useState(false);

  const handleExportFile = (format: ExportFormat) => {
    const saveTo = (fileName || "untitled") + "." + format;
    setExporting(true);

    exportToXls(data, saveTo, sheetName).then(() => {
      setExporting(false);
    });
  };

  // @ts-ignore
  return (
    <ExportsDialogButtons>
      {formats.map((format) => (
        <Tooltip title={"Export to " + format} key={"export" + format} arrow>
          <ButtonHolder>
            {exporting && (
              <div className={"exporting"}>
                <CircularProgress size={16} />
              </div>
            )}
            <IconButton
              size={"small"}
              onClick={() => handleExportFile(format)}
              disabled={disabled || exporting}
            >
              {FormatsIcons[format]}
            </IconButton>
          </ButtonHolder>
        </Tooltip>
      ))}
    </ExportsDialogButtons>
  );
};

export default ExportsDialog;
